import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MasterService } from "../../pages/master/master.service";
import { PurchaseOrderService } from "../../pages/purchase-order/purchase-order-service";

@Component({
  selector: "app-other-charges-dialog",
  templateUrl: "./other-charges-dialog.component.html",
  styleUrls: ["./other-charges-dialog.component.scss"],
})
export class OtherChargesDialogComponent implements OnInit {
  public otherChargesForm: UntypedFormGroup;
  public otherChargesColumns = [
    "Other Charges Type *",
    "Amount *",
    "GST (%)*",
    "Net Amount",
    "Action",
  ];
  otherChargesTypes: any[] = [{ id: 1, text: "type 1" }];
  gstList: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<OtherChargesDialogComponent>,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private masterService: MasterService,
    private poService: PurchaseOrderService
  ) {
    dialogRef.disableClose = true;
    this.getAllGstMaster();
    this.buildForm();
  }
  buildForm() {
    this.otherChargesForm = this.fb.group({
      otherChargesDetails: this.fb.array([]),
    });
    if (this.data) {
      this.data?.map(this.onNewItemAdded)
    } else {
      this.onNewItemAdded();
    }
  }
  get otherChargesDetails() {
    return (this.otherChargesForm.get("otherChargesDetails") as FormArray)
      .controls;
  }
  onNewItemAdded = (data?) => {
    (this.otherChargesForm.get("otherChargesDetails") as FormArray).push(
      this.fb.group({
        otherChargesType: [data?.otherChargesType || 0, Validators.required],
        amount: [data?.amount || 0, Validators.required],
        gstPercent: [data?.gstPercent || 0, Validators.required],
        netAmount: [data?.netAmount || 0],
      })
    );
  }
  onDeleteItem(index: number) {
    (this.otherChargesForm.get("otherChargesDetails") as FormArray).removeAt(
      index
    );
  }
  ngOnInit(): void {
    this.getAllOtherCharges();
  }
  getAllGstMaster() {
    this.masterService.getAllGst().subscribe((res) => {
      this.gstList = res;
    });
  }
  onQuantityChange(e, index) {
    const amount = this.otherChargesDetails[index].get("amount").value;
    const gstPercent = this.otherChargesDetails[index].get("gstPercent").value;
    this.otherChargesDetails[index]
      .get("netAmount")
      ?.setValue(amount + gstPercent);
    this.otherChargesDetails[index].get("netAmount").disable();
  }
  close(): void {
    this.dialogRef.close();
  }
  onSave() {
    this.dialogRef.close(this.otherChargesForm.get('otherChargesDetails').getRawValue());
  }
  getAllOtherCharges() {
    this.poService.getAllTermsByType("OTHER_CHARGES").subscribe(res => {
    this.otherChargesTypes = res;
    })
  }
}
